// Catalog of geoVINUM static helpers.
// All product / lesson / quiz mocks were removed: products now come from WooCommerce,
// courses from Tutor LMS (via /api/woo and /api/tutor in the FastAPI proxy).
// What remains here is purely structural data that does not exist in WP.

export const PRODUCTS = [];
export const COLLECTIONS = [];
export const LESSONS = [];
export const QUIZZES = [];

// Backwards-compatibility helpers used by a few legacy pages that we redirect.
export function findProduct() { return null; }
export function relatedProducts() { return []; }
export function searchCatalog() { return { regions: [], products: [], lessons: [], quizzes: [], total: 0 }; }
